import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DatabasePostService {
    serviceBase = environment.API_URL + '/api/database';
    queryString: string;

    constructor(private http: HttpClient) { }

    getCountryList(filterData): any {
        this.queryString = '/getCountryListData';
        return this.http.post<any>(this.serviceBase + this.queryString, filterData);
    }

    getAllLists(dropdownList: any) {
        this.queryString = '/getAllLists';
        return this.http.post<any>(this.serviceBase + this.queryString, dropdownList);
    }
    saveTableListArchiveData(tableListData, tableName) {
        switch (tableName) {
            case 'Country List':
                this.queryString = '/updateCountry?id=' + tableListData.id;
                break;
            case 'City List':
                this.queryString = '/updateCity?id=' + tableListData.id;
                break;
            case 'City Utility Cost':
                this.queryString = '/updateCityUtilityCost?id=' + tableListData.id;
                break;
            case 'City Basecase LPD':
                this.queryString = '/updateCityLpd?id=' + tableListData.id;
                break;
            case 'City Basecase Materials':
                this.queryString = '/updateCityBaseCaseMaterial?id=' + tableListData.id;
                break;
            case 'City Basecase Material Thickness':
                this.queryString = '/updateCityMaterialThickness?id=' + tableListData.id;
                break;
            case 'City Water Fixture Base Case Flow':
                this.queryString = '/updateCityWaterFixtureBaseCaseFlow?id=' + tableListData.id;
                break;
            case 'City BaseCase WallUValue':
                this.queryString = '/updateCityBaseCaseWallUValue?id=' + tableListData.id;
                break;
            case 'City BaseCase RoofUValue':
                this.queryString = '/updateCityBaseCaseRoofUValue?id=' + tableListData.id;
                break;
            case 'City BaseCase GlassUValue':
                this.queryString = '/updateCityBaseCaseGlassUValue?id=' + tableListData.id;
                break;
            case 'City BaseCase SHGCValue':
                this.queryString = '/updateCityBaseCaseSHGCValue?id=' + tableListData.id;
                break;
        }
        //let queryString = '/updateCountry?id=' + tableListData.id;
        return this.http.post<any>(this.serviceBase + this.queryString, tableListData);
    }
    
    addTableList(countryListObj,tableName) {
        switch (tableName) {
            case 'Country List':
                this.queryString = '/addCountry';
                break;
            case 'City List':
                this.queryString = '/addCity';
                break;
            case 'City Utility Cost':
                this.queryString = '/addCityUtilityCost';
                break;
            case 'City Basecase LPD':
                this.queryString = '/addCityLpd';
                break;
            case 'City Basecase Materials':
                this.queryString = '/addCityBaseCaseMaterial';
                break;
            case 'City Basecase Material Thickness':
                this.queryString = '/addCityMaterialThickness';
                break;
            case 'City Water Fixture Base Case Flow':
                this.queryString = '/addCityWaterFixtureBaseCaseFlow';
                break;
            case 'City BaseCase WallUValue':
                this.queryString = '/addCityBaseCaseWallUValue';
                break;
            case 'City BaseCase RoofUValue':
                this.queryString = '/addCityBaseCaseRoofUValue';
                break;
            case 'City BaseCase GlassUValue':
                this.queryString = '/addCityBaseCaseGlassUValue';
                break;
            case 'City BaseCase SHGCValue':
                this.queryString = '/addCityBaseCaseSHGCValue';
                break;
        }        
        return this.http.post<any>(this.serviceBase + this.queryString, countryListObj);
    }    
}
